export function transformPreviousMarriages(formData) {
  const parsedFormData = JSON.parse(formData);
  const transformedValue = { ...parsedFormData };
  const selections = parsedFormData?.hadPreviousMarriages;

  if (selections && typeof selections === 'object') {
    transformedValue.hadPreviousMarriages = Boolean(
      selections.claimant || selections.veteran,
    );
  } else if (parsedFormData?.claimantRelationship === 'SURVIVING_SPOUSE') {
    transformedValue.hadPreviousMarriages = false;
  }

  return JSON.stringify(transformedValue);
}
